<template>
    <div class="testimonials-container">
        <div class="testimonial-row">
            <div class="testimonialSection" v-for="testimonial in randomTestimonials" :key="testimonial.id">
                <div class="testimonialTop">
                <div class="testimonialNameRating">
                    
                    <h2>{{ testimonial.name }}</h2>
                <div class="google-rating">
                    <span v-for="rating in testimonial.ratings" :key="rating" class="star"></span>
                </div>
                </div>
                    
                </div>

                <div class="testimonialDescription">{{ testimonial.description }}</div>

            </div>
        </div>
        
        <div class="view-all-reviews">
            <a href="https://www.google.com/search?q=Homes+Roofing+Co+LLC+Reviews" target="_blank" rel="noopener" class="google-reviews-link">
                <span class="google-icon">G</span>
                View All Google Reviews
            </a>
            <a href="https://www.google.com/search?sca_esv=7782a288a773db31&sxsrf=ANbL-n6SUpBS422hbFqxCDtXW4E2A3W8rA:1771024332985&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOQcSWWd4c0jLy9B1Tewa0yfGVeNx5VQtEiVb8RGcFCPUtoIpczm_ozg7bQBBmK9J6fi9ir4ux8GQkVRWrBy_oaQyFQa58nYkN7BLWOS7rFWqrYtmDQ%3D%3D&q=Homes+Roofing+Co+LLC+Reviews&sa=X&ved=2ahUKEwjkgYbiy9eSAxXVExAIHculGKoQ0bkNegQIKBAF&biw=766&bih=791&dpr=1.25" target="_blank" rel="noopener" class="leave-review-link">
                ⭐ Leave Us a Review
            </a>
        </div>
    </div>
</template>




<style scoped>
.testimonial-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}
</style>

<script>

import {testimonials as Importedtestimonials} from '../components/TestimonialsRepo.js';

export default {
    name: 'CustomerTestimonials',
    data() {
        return {
            testimonials: Importedtestimonials
        };
    },

    computed: {
        randomTestimonials() {
            let testimonials = [...this.testimonials]; // Create a copy of the testimonials array
            for (let i = testimonials.length - 1; i > 0; i--) { // Shuffle the array
                let j = Math.floor(Math.random() * (i + 1));
                [testimonials[i], testimonials[j]] = [testimonials[j], testimonials[i]];
            }
            return testimonials.slice(0, 4); // Return the first 4 elements
        },
    },
};
</script>

<style scoped>
/* Desktop Styling */
.testimonial-row {
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    background: transparent;
    color: #f0f0f0;
    padding: 10px
}
    .google-rating {
        display: flex;
    }.star {
  width: 30px;
  height: 30px;
  background-color: #f1c40f;
  margin: 0 2px;
  clip-path: polygon(
    50% 0%, 
    61% 35%, 
    98% 35%, 
    68% 57%, 
    79% 91%, 
    50% 70%, 
    21% 91%, 
    32% 57%, 
    2% 35%, 
    39% 35%
  );
}
    .testimonialNameRating {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .testimonialSection {
        width: 30%;
        margin: 10px;
        padding: 10px;
        border-radius: 10px;
        background-color: #f0f0f0;
        color: #002655;
    }
    .testimonialSection {
        width: 45%;
        padding: 10px;
        
    }
    .testimonialDescription {
        padding-top: 10px;
        font-weight: bold;
    }

    @media (min-width: 880px) {
        .testimonialSection {
            transition: transform 0.3s ease-in-out;
        }
        .testimonialSection:hover {
        outline-style: solid;
        transform: scale(1.05); /* Scale up the container by 5% when hovered over */
    }
    }



/* Mobile Styling */
@media (max-width: 880px) {

    .testimonialSection {
        width: 80%;
        padding: 10px;
        
    }

    .testimonialTop {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-left: 10px;
    }
    .testimonial-row {
        display: flex;
        flex-direction: column;
        align-items: center;
         font-family: 'Lato', sans-serif; /* Use Lato font */
    }
    .testimonialNameRating {
        width: 100%;
        
        h2{
            font-size: 1.5em;
            margin-bottom: 10px;
        }
    }
    .google-rating{
        margin-bottom: 10px;
    }

    .view-all-reviews {
        margin-top: 20px;
    }

    .google-reviews-link {
        padding: 12px 25px;
        font-size: 1rem;
    }
}

/* View All Reviews Button */
.testimonials-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.view-all-reviews {
    margin-top: 30px;
    margin-bottom: 20px;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
}

.google-reviews-link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background-color: #002655;
    color: white;
    padding: 15px 30px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 1.1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    border: 2px solid #f1c40f;
}

.google-reviews-link:hover {
    background-color: #1a3a5c;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 38, 85, 0.3);
}

.google-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #4285F4, #34A853, #FBBC05, #EA4335);
    color: white;
    font-weight: bold;
    border-radius: 4px;
    font-size: 1rem;
}

.leave-review-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: #f1c40f;
    color: #002655;
    padding: 15px 30px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 1.1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    border: 2px solid #002655;
}

.leave-review-link:hover {
    background-color: #d4a90a;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(241, 196, 15, 0.4);
}
</style>




